import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["slide", "controls", "previous", "next", "status"]

  connect() {
    this.index = 0
    this.controlsTarget.hidden = this.slideTargets.length < 2
    this.show()
  }

  previous(event) {
    if (event) event.preventDefault()
    if (this.index > 0) {
      this.index -= 1
      this.show()
    }
  }

  next(event) {
    if (event) event.preventDefault()
    if (this.index < this.slideTargets.length - 1) {
      this.index += 1
      this.show()
    }
  }

  show() {
    this.slideTargets.forEach((slide, index) => { slide.hidden = index !== this.index })
    this.previousTarget.disabled = this.index === 0
    this.nextTarget.disabled = this.index >= this.slideTargets.length - 1
    this.statusTarget.textContent = `${this.index + 1} of ${this.slideTargets.length}`
  }

  startSwipe(event) {
    if (event.pointerType !== "touch" || !event.isPrimary) return
    this.swipeStart = { id: event.pointerId, x: event.clientX, y: event.clientY }
  }

  endSwipe(event) {
    const start = this.swipeStart
    this.cancelSwipe()
    if (!start || start.id !== event.pointerId) return
    const distanceX = event.clientX - start.x
    const distanceY = event.clientY - start.y
    if (Math.abs(distanceX) < 50 || Math.abs(distanceX) <= Math.abs(distanceY)) return
    if (distanceX < 0) this.next()
    else this.previous()
  }

  cancelSwipe() {
    this.swipeStart = null
  }

  disconnect() {
    this.cancelSwipe()
  }
}
